import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button, Table, Spin, DatePicker, Space } from "antd";
import PropTypes from "prop-types"; // Importar PropTypes
import api from "../../../axiosConfig";
import { format } from "date-fns";
import { es } from "date-fns/locale";
// import dayjs from "dayjs"; // No se está usando actualmente

const UserHistoryDialog = ({ userId, open, handleClose }) => {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null); // Cambiar a null para no filtrar por fecha por defecto
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchHistorial = useCallback(
    async (date = selectedDate, page = 1) => {
      try {
        setLoading(true);
        const params = {
          page,
          limit: pagination.pageSize,
        };

        // Solo agregar fecha si se selecciona una
        if (date && date.isValid()) {
          params.fecha = date.format("YYYY-MM-DD");
        }


        const response = await api.get(`/historial-usuario/${userId}`, {
          params,
        });


        setHistorial(response.data.data || []);
        setPagination((prev) => ({
          ...prev,
          current: response.data.page,
          total: response.data.total,
        }));
      } catch (error) {
        console.error("Error al obtener el historial:", error);
      } finally {
        setLoading(false);
      }
    },
    [userId, selectedDate, pagination.pageSize]
  );

  useEffect(() => {
    if (open) {
      fetchHistorial();
    }
  }, [open, fetchHistorial]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchHistorial(date, 1);
  };

  const handleTableChange = (newPagination) => {
    fetchHistorial(selectedDate, newPagination.current);
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (
        <>
          {format(new Date(createdAt), "PPP", { locale: es })}{" "}
          {format(new Date(createdAt), "p", { locale: es })}
        </>
      ),
    },
    {
      title: "Acción",
      dataIndex: "accion",
      key: "accion",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title="Historial de Usuario"
      footer={[
        <Button key="close" onClick={handleClose} type="primary">
          Cerrar
        </Button>,
      ]}
      width={800}
    >
      <Space direction="vertical" style={{ width: "100%", marginBottom: 16 }}>
        <Space>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            format="DD/MM/YYYY"
            style={{ width: 200 }}
            placeholder="Seleccionar fecha"
          />
          <Button
            onClick={() => {
              setSelectedDate(null);
              setPagination((prev) => ({ ...prev, current: 1 }));
              fetchHistorial(null, 1);
            }}
          >
            Limpiar filtro
          </Button>
        </Space>
      </Space>

      {loading ? (
        <div style={{ textAlign: "center" }}>
          <Spin />
        </div>
      ) : (
        <>
          {historial.length === 0 ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <p>No se encontraron registros de historial para esta fecha.</p>
              <p>Total de registros: {pagination.total}</p>
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={historial}
              rowKey="id"
              pagination={{
                ...pagination,
                showSizeChanger: false,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} de ${total} registros`,
              }}
              onChange={handleTableChange}
            />
          )}
        </>
      )}
    </Modal>
  );
};

// Validación de PropTypes
UserHistoryDialog.propTypes = {
  userId: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default UserHistoryDialog;
